import { Button, Grid } from "@material-ui/core";
import CircularLoader from "../../../../../components/loading/circularLoader";
import { Print } from "@material-ui/icons";
import moment from "moment";
import { useContext, useState } from "react";
import { QueryParamsContext } from "../../../../../context/QueryParamsContext";
import { printInvoiceMirrorPDF } from "../../../../../repositories/qerpapi/erp/relatorio/EspelhoFaturamentoRepository";
import { b64toBlob } from "../../../../../utils/file64toBlob";
import { notify } from "../../../../../utils/notify";
import { periods } from "../../../../financeiro/constants";
import {
  invoiceMirrorContractModality,
  invoiceMirrorContractStatus,
  invoiceMirrorDateType,
} from "../../constants";
import { useEspelhoFaturamentoService } from "../../context/EspelhoFaturamentoContext";
import ExportButton from "../ExportButton";

export const ReportActions = () => {
  const [printLoading, setPrintLoading] = useState(false);
  const {
    columns,
    cachedInvoicing,
    filters,
    cachedCompanies,
    cachedClients,
    formatSortedLabel,
    formatGroupedLabel,
    cachedSituations,
    quickSituations,
  } = useEspelhoFaturamentoService();
  const { queryParams } = useContext(QueryParamsContext);

  const { data, isGrouped } = cachedInvoicing;

  const handlePrintToPdf = async () => {
    const filtersDescriptions = {
      period: {
        label: "Período",
        formatedValue: (searchPeriod) => {
          const objEntries = Object.entries(periods);
          const [key] = objEntries.find(([_, value]) => value === searchPeriod);
          return key;
        },
      },
      startDate: {
        label: "Data inicial",
        formatedValue: (date) =>
          moment(date, "YYYY-MM-DD").format("DD/MM/YYYY"),
      },
      endDate: {
        label: "Data final",
        formatedValue: (date) =>
          moment(date, "YYYY-MM-DD").format("DD/MM/YYYY"),
      },

      multicompany: {
        label: "Empresa",
        formatedValue: (company) => {
          const objEntries = Object.entries(cachedCompanies);
          const companies = objEntries.find(([_, value]) => value === company);
          return companies.length > 0 ? companies[0] : queryParams?.nomeempresa;
        },
      },

      customer: {
        label: "Cliente",
        formatedValue: (customer) => {
          if (!customer) return "Todos";

          const customers = cachedClients.find(
            ({ value }) => value === customer
          );
          return customers[0] ?? queryParams?.nomeempresa;
        },
      },

      multipleSort: {
        label: "Ordenado por:",
        formatedValue: formatSortedLabel,
      },
      contractStatus: {
        label: "Status Contrato",
        formatedValue: (statusFilter) => {
          const objEntries = Object.entries(invoiceMirrorContractStatus);
          const [key] = objEntries.find(([_, value]) => value === statusFilter);
          return key;
        },
      },
      contractNumber: {
        label: "Nº Contrato",
        formatedValue: (contractNumber) => `Contrato Nº ${contractNumber}`,
      },
      contractModality: {
        label: "Modalidade Contrato",
        formatedValue: (modality) => {
          const objEntries = Object.entries(invoiceMirrorContractModality);
          const [key] = objEntries.find(([_, value]) => value === modality);
          return key;
        },
      },
      accountReceivableStatus: {
        label: "Situações",
        formatedValue: (_) => {
          const status = cachedSituations
            .filter((situation) =>
              filters.accountReceivableStatus?.includes(situation.id)
            )
            .map((situation) => situation.desc);
          return status.join(", ");
        },
      },
      accountReceivableQuickStatus: {
        label: "Situações Rápidas",
        formatedValue: (_) => {
          const status = quickSituations
            .filter((situation) =>
              filters.accountReceivableQuickStatus?.includes(situation.id)
            )
            .map((situation) => situation.desc);
          return status.join(", ");
        },
      },
      dateFilter: {
        label: "Data de",
        formatedValue: (statusFilter) => {
          const objEntries = Object.entries(invoiceMirrorDateType);
          const [key] = objEntries.find(([_, value]) => value === statusFilter);
          return key;
        },
      },
    };

    setPrintLoading(true);

    const pdfBody = {
      title: "Relatório de Espelho de Faturamento",
      type: "DETALHADO",
      order: formatSortedLabel(filters.multipleSort),
      group: formatGroupedLabel(filters.group),
      companyName: queryParams?.nomeempresa,
      companyFantasy: queryParams?.apelido,
      headerLogo: queryParams?.imagebase64,
      footerLogo: queryParams?.imagebase64,
      login: queryParams?.usuario_nome,
      filter: Object.entries(filters)
        .filter(([key, _]) => !!filtersDescriptions[key])
        .map(([key, value]) => ({
          field: filtersDescriptions[key].label,
          value: filtersDescriptions[key].formatedValue(value),
        })),
      movement: data,
      searchPeriod: cachedInvoicing.period,
      total: {
        amount: 0,
        balance: 0,
        originalAmount: 0,
        debit: 0,
        debitPerCent: 0,
        credit: 0,
        creditPerCent: 0,
        increase: 0,
        discount: 0,
      },
    };
    const res = await printInvoiceMirrorPDF(pdfBody);
    setPrintLoading(false);
    if (res?.status !== 200) {
      return notify("Falha ao imprimir relatório", true, "error");
    }

    const blob = b64toBlob(res?.data?.fileBase64, "application/pdf");
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl);
  };

  const isEmpty = data.every((item) => !item.elements.length);

  return (
    <Grid item container direction="row" spacing={1}>
      <Grid item xs />
      <Grid item>
        <ExportButton
          data={data}
          filename={`espelho-faturamento-${Date.now()}`}
          columns={columns}
          isGrouped={isGrouped}
        />
      </Grid>
      <Grid item>
        <Button
          size="small"
          variant="contained"
          startIcon={printLoading ? <CircularLoader /> : <Print />}
          color="primary"
          disabled={printLoading || isEmpty}
          onClick={handlePrintToPdf}
        >
          {printLoading ? "Gerando relatório..." : "Imprimir"}
        </Button>
      </Grid>
    </Grid>
  );
};
